const mutations = {
    setEmployments(state,payload) {
        state.employments = payload
    },
    setEmployment(state,payload) {
        state.employment = payload
    }
}

export default mutations

